import { useTranslation } from 'react-i18next'
import SiteLayout from '@/components/feature/SiteLayout'
import PageHeader from '@/components/feature/PageHeader'
import ContactSection from '@/components/feature/sections/ContactSection'
import { brandInfo } from '@/mocks/site'

export default function Contact() {
  const { t } = useTranslation()

  return (
    <SiteLayout>
      <PageHeader
        breadcrumb={t('pages.contact.breadcrumb')}
        label={t('pages.contact.label')}
        title={t('pages.contact.title')}
        description={t('pages.contact.description', { phone: brandInfo.phone })}
        image="https://readdy.ai/api/search-image?query=warm%20welcoming%20photography%20studio%20reception%20with%20soft%20golden%20lighting%2C%20elegant%20interior%2C%20framed%20portraits%20and%20a%20cosy%20consultation%20desk%2C%20deep%20brown%20and%20amber%20tones%2C%20premium%20editorial%20atmosphere&width=1920&height=900&seq=shabi-hdr-contact&orientation=landscape"
        imageAlt="Shabi Media studio reception with warm golden lighting"
      />
      <ContactSection />
    </SiteLayout>
  )
}